import {DateTime} from 'luxon'

/**
 * Return true it has expired token or no token
 * @param expiredAt
 * @param token
 * @param local
 */
export function isExpiredToken(
  expiredAt: number | null,
  token: string | null = '',
  local: any = DateTime.local()
): boolean {
  if(!expiredAt || !token) {
    return true
  }
  const expired = DateTime.fromMillis(expiredAt)
  return expired.diff(local, 'minutes').minutes < 10
}
